import { Features, selectHasFeature } from "@/store/features/features-slice";
import { useAppSelector } from "@/store/store-hooks";
import { FaroButton, FaroText, grey } from "@faro-lotv/flat-ui";
import { Stack } from "@mui/material";
import type { JSX } from "react";
import { useFloorSampleCaptureStore } from "./use-capture-floor-sample";

/** @returns for developers, the button saving the selected points as a sample for the floor area estimation */
export function FloorSampleCaptureButton(): JSX.Element | null {
  const isEnabled = useAppSelector(
    selectHasFeature(Features.IpxFloorSampleCapture),
  );
  const { status, scope, sampledPoints, error, request } =
    useFloorSampleCaptureStore();
  if (!isEnabled) return null;

  return (
    <Stack sx={{ gap: 0.5, alignItems: "flex-start" }}>
      <Stack direction="row" sx={{ gap: 1 }}>
        <FaroButton
          variant="ghost"
          size="s"
          onClick={() => request("region")}
          isLoading={status !== "idle" && scope === "region"}
          disabled={status !== "idle"}
        >
          Capture floor sample
        </FaroButton>
        <FaroButton
          variant="ghost"
          size="s"
          onClick={() => request("whole")}
          isLoading={status !== "idle" && scope === "whole"}
          disabled={status !== "idle"}
        >
          Capture whole point cloud
        </FaroButton>
      </Stack>
      {status === "capturing" && (
        <FaroText variant="bodyS" color={grey[600]}>
          {`${sampledPoints.toLocaleString()} points collected…`}
        </FaroText>
      )}
      {error && (
        <FaroText variant="bodyS" color="error.main">
          {error}
        </FaroText>
      )}
    </Stack>
  );
}
